var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeenyiconsPasswordOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 13.6V12C19.9998 11.5756 19.8312 11.1687 19.5312 10.8686C19.2311 10.5686 18.8242 10.4 18.3998 10.4H2.3998C1.97546 10.4 1.56849 10.5686 1.26843 10.8686C0.968376 11.1687 0.799805 11.5756 0.799805 12V21.6C0.799805 22.0243 0.968376 22.4313 1.26843 22.7314C1.56849 23.0314 1.97546 23.2 2.3998 23.2H18.3998C18.8242 23.2 19.2311 23.0314 19.5312 22.7314C19.8312 22.4313 19.9998 22.0243 19.9998 21.6V20M19.9998 13.6H13.5998C12.7511 13.6 11.9372 13.9371 11.3371 14.5372C10.7369 15.1374 10.3998 15.9513 10.3998 16.8C10.3998 17.6487 10.7369 18.4626 11.3371 19.0627C11.9372 19.6628 12.7511 20 13.5998 20H19.9998M19.9998 13.6C20.8485 13.6 21.6624 13.9371 22.2625 14.5372C22.8627 15.1374 23.1998 15.9513 23.1998 16.8C23.1998 17.6487 22.8627 18.4626 22.2625 19.0627C21.6624 19.6628 20.8485 20 19.9998 20M5.5998 10.4V5.59999C5.5998 4.32695 6.10552 3.10605 7.00569 2.20588C7.90587 1.3057 9.12677 0.799988 10.3998 0.799988C11.6728 0.799988 12.8937 1.3057 13.7939 2.20588C14.6941 3.10605 15.1998 4.32695 15.1998 5.59999V10.4M19.1998 16.8H20.7998M15.9998 16.8H17.5998M12.7998 16.8H14.3998",
    stroke: "#616161",
    strokeOpacity: 0.7,
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_3598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsPasswordOutline);
export default __webpack_public_path__ + "static/media/teenyicons_password-outline.8e002bfff8717abd0d84c57a43d8a0d8.svg";
export { ForwardRef as ReactComponent };